import { createContext, useContext } from 'react';

interface NavSectionContextValue {
  readonly setActiveSection: (section: string | null) => void;
}

export const NavSectionContext = createContext<NavSectionContextValue | null>(null);

export function useNavSection(): NavSectionContextValue {
  const ctx = useContext(NavSectionContext);
  if (ctx == null) throw new Error('useNavSection must be used within NavSectionContext.Provider');
  return ctx;
}
